import React, { useState, useRef } from "react";
import useTableScroll from "../../useTableScrollcesar";
import { AgylsoftModal, Mensaje, MensajeSiNo } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import axios from "axios";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import { formatMoneda, validaSoloNumero } from "../../../util/varios";
import CatalogoComercio from "../../../catalogos/catalogoComercio";
import CatalogoInmueble from "../../../catalogos/catalogoInmueble";
import CatalogoVehiculo from "../../../catalogos/catalogoVehiculosAll";
import CatalagoRentasInmo from "../../../catalogos/catalogoRentasInm2";
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";
import { Input, SearchInput, Textarea } from "../../../ui/inputs/Input";

export const FacturaPago = (props) => {
  moment.locale("es-us");

  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const anioActu = JSON.parse(localStorage.getItem("anioactu"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const txtContribuyente = useRef();
  const chkSeleccionarDeuda = useRef([]);

  const [idTipIngre, setIdTipIngre] = useState();
  const [idTipIngreMulta, setIdTipIngreMulta] = useState();
  const [idTipIngreRS, setIdTipIngreRS] = useState();
  const [nomTablaContri, setNomTablaContri] = useState();
  const [nomTabla, setNomTabla] = useState();
  const [tipoImpu, setTipoImpu] = useState();
  const [nomTablaDeuda, setNomTablaDeuda] = useState();
  const [idComercio, setIdComercio] = useState(0);
  const [idRenta, setIdRenta] = useState(0);
  const [codImpu, setCodImpu] = useState(0);

  const [disponiblesDeuda, setDisponiblesDeuda] = useState(0);
  const [catalogoC, setCatalogoC] = useState(false);
  const [catalogoI, setCatalogoI] = useState(false);
  const [catalogoV, setCatalogoV] = useState(false);
  const [catalogoA, setCatalogoA] = useState(false);
  const [cuentasBanca, setCuentasBanca] = useState("0");
  const [tabla] = useState(null);
  const [tipoPago, setTipoPago] = useState("");
  const [efectivo1, setEfectivo1] = useState("0,00");
  const [efectivo2, setEfectivo2] = useState("0,00");
  const [fechaD1, setFechaD1] = useState("");
  const [fechaD2, setFechaD2] = useState("");
  const [numeroD1, setNumeroD1] = useState("");
  const [numeroD2, setNumeroD2] = useState("");
  const [montoT1, setMontoT1] = useState("0,00");
  const [montoT2, setMontoT2] = useState("0,00");
  const [montoT3, setMontoT3] = useState("0,00");
  const [fechaT1, setFechaT1] = useState("");
  const [fechaT2, setFechaT2] = useState("");
  const [fechaT3, setFechaT3] = useState("");
  const [numeroT1, setNumeroT1] = useState("");
  const [numeroT2, setNumeroT2] = useState("");
  const [numeroT3, setNumeroT3] = useState("");
  const [banCliT1, setBanCliT1] = useState("0");
  const [banCliT2, setBanCliT2] = useState("0");
  const [banCliT3, setBanCliT3] = useState("0");
  const [disabledAnio2, setDisabledAnio2] = useState(false);

  const [titulo] = useState();
  const [msg] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [factorCambio, setFactorCambio] = useState(0);

  const [btnDisabled, setBtnDisabled] = useState(true);
  const [idcontribuyente] = useState(null);
  const [deuda, setDeuda] = useState([]);
  const [multa, setMulta] = useState([]);
  const [disabledDeuda, setDisabledDeuda] = useState(false);
  const [disabledMulta, setDisabledMulta] = useState(false);
  const [disabledAnio, setDisabledAnio] = useState(false);
  const [disabledId, setDisabledId] = useState(false);
  const [agyl, setAgyl] = useState({
    show: false,
    number: 0,
    contracts: [],
  });
  const [totalSelect, setTotalSelect] = useState({
    concepto: "",
    seleccionados: "",
    montoseleccionado: "",
    acrediSelect: "",
    montoFacturadoSelect: "",
    interesesSelect: "",
    multaSelect: "",
    recargoSelect: "",
    retenSelect: "",
  });

  const [valuess, setValuess] = useState({
    idcontribuyente: "",
    nombre: "",
    rif: "",
    direccion: "",
  });

  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");

  const headCells = [
    { label: "#", textAlign: "center" },
    { label: "Año", textAlign: "center" },
    { label: "Mes", textAlign: "center" },
    { label: "Monto", textAlign: "right" },
    { label: "Intereses Mora", textAlign: "right" },
    { label: "Multas", textAlign: "right" },
    { label: "Recargo", textAlign: "right" },
    { label: "Retenciones", textAlign: "right" },
    { label: "Crédito", textAlign: "right" },
    { label: "Total", textAlign: "right" },
    { label: "Estatus", textAlign: "center" },
  ];

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const onChange = (e) => {
    setValuess({ ...valuess, [e.target.name]: e.target.value });
    if (e.target.name === "idcontribuyente") {
      validaSoloNumero(e);
    }
  };

  const seleccionartipoIngreso = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "tipoimpuesto";
    let condi = "tipofacturacion = 1";
    let orden = "idtipoimpuesto";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          for (let i = 0; i < response.data.length; i++) {
            if (props.tipo === i) {
              setIdTipIngre(response.data[i].idtipoingreso);
              break;
            }
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionartipoIngresoMulta = () => {
    setActivate(true);
    let campos = "*";
    let nomtab = "tipoimpuesto";
    let condi = "tipofacturacion = 3";
    let orden = "idtipoimpuesto";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          for (let i = 0; i < response.data.length; i++) {
            setIdTipIngreMulta(response.data[i].idtipoingreso);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionartipoIngresoRS = () => {
    setActivate(true);
    let campos = "*";
    let nomtab = "tipoimpuesto";
    let condi = "idtipoimpuesto = 45";
    let orden = "idtipoimpuesto";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          for (let i = 0; i < response.data.length; i++) {
            setIdTipIngreRS(response.data[i].idtipoingreso);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarValorPetro = () => {
    setActivate(true);
    let campos = "*";
    let nomtab = "valorpetro";
    let condi =
      "fechaaplic = (SELECT MAX(fechaaplic) AS fecha FROM valorpetro)";
    let orden = "1";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          for (let i = 0; i < response.data.length; i++) { }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SelectDeudaC = (idcomercio, fecha, espiritu) => {
    let endpoint;
    if (espiritu === 0) {
      endpoint = `${op.conexion
        }/api/industria/deudacomerciors?idcomercio=${idcomercio}&fecha=${fecha}&espiritu=${espiritu}&tipounid=${1}`;
    } else {
      endpoint = `${op.conexion
        }/api/industria/deudacomercio?idcomercio=${idcomercio}&fecha=${fecha}&espiritu=${espiritu}&tipounid=${1}`;
    }
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var deu = [];
          var his = [];
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                retenciones: response.data[i].retencion,
                credito: response.data[i].acreditacion,
                totalperi: response.data[i].subtotal,
                status: response.data[i].estatus,
                idfac: response.data[i].idfact,
                nummes: response.data[i].nmes,
                estatusfac: response.data[i].estatusfac,
                tipotransaccion: response.data[i].tipotransaccion,
                tipodeuda: response.data[i].tipodeuda,
                nombredeuda:
                  espiritu === 0
                    ? response.data[i].nombredeuda
                    : "deudacomercio",
                idrent: espiritu === 0 ? response.data[i].idrent : 0,
              });
              if (espiritu === 0) {
                if (response.data[i].nombredeuda === "deudarentas") {
                  setIdRenta(response.data[i].idrent);
                }
              }
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
                status: response.data[i].estatus,
                idfac: response.data[i].idfact,
                estatusfac: response.data[i].estatusfac,
                tipotransaccion: response.data[i].tipotransaccion,
              });
            }
          }
          setDeuda(deu);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const SelectDeuda = (id) => {
    let endpoint = "";
    let factorCambioLocal = 1;

    // Asegúrate de tener acceso a props, por ejemplo pasándolo como parámetro
    // const SelectDeuda = (id, props) => {

    switch (props.tipo) {
      case 0:
        // Asigna un endpoint o maneja este caso
        break;
      case 1:
        endpoint = `${op.conexion}/api/inmueble/deudainmueble?idinmueble=${id}&fecha=${fechaSistema}&espiritu=${espiritu}`;
        factorCambioLocal = factorCambio;
        break;
      case 2:
        endpoint = `${op.conexion}/api/vehiculo/deudavehiculo?idvehiculo=${id}&fecha=${fechaSistema}&espiritu=${espiritu}`;
        break;
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
        let tabla = "aseo";
        // NO redeclares endpoint aquí, solo asígnale un valor
        if (espiritu === 0) {
          endpoint = `${op.conexion}/api/aseo/deudarenta?idrentas=${id}&fecha=${fechaSistema}&tabla=${tabla}`;
        } else {
          //endpoint = `${op.conexion}/api/aseo/deudarenta1?idrentas=${id}&fecha=${fechaSistema}&tabla=${tabla}`;
          endpoint = `${op.conexion}/api/aseo/deudarenta?idrentas=${id}&fecha=${fechaSistema}&tabla=${tabla}`;
        }
        break;
      default:
        // Asigna un endpoint o maneja este caso
        break;
    }

    // Verifica que endpoint no esté vacío antes de hacer la petición
    if (!endpoint) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "No se pudo determinar el endpoint para la consulta",
        icono: "error",
      });
      setActivate(false);
      return;
    }

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var deu = [];
          var his = [];
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu === null ? "0.00" : response.data[i].intmoradeu,
                retenciones: "0.00",
                credito: "0.00",

                totalperi: response.data[i].subtotal,
                status: response.data[i].estatus,
                nummes: response.data[i].nmes,
                multa: "0.00",
                recargo: response.data[i].recargodeu,
              });
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
              });
            }
          }

          setDeuda(deu);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response ? error.response.data.message : error.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SelectIdComercioFact = (idinmue) => {
    let endpoint = `${op.conexion}/api/Caja_Ingreso/selectIdComercioFactura?idinmue=${idinmue}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setIdComercio(
            response.data.idcomercio === null ? 0 : response.data.idcomercio
          );
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const procesarFactura = (body) => {
    let endpoint = `${op.conexion}/api/Caja_Ingreso/crearfactura`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        setActivate(false);
        if (response.status == 200) {
          valuess.idcontribuyente = "";
          valuess.rif = "";
          valuess.nombre = "";
          valuess.direccion = "";
          props.onHideAcepta();
          blanquear();
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const procesarpago = (body) => {
    let endpoint = `${op.conexion}/api/agenteweb/procesarpago`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto:
              "Estimado contribuyente, hacemos de su conocimiento que el procedimiento de verificación de pago tiene un tiempo estimado de 72 horas, una vez conciliado el mismo, será enviado vía correo electrónico, el correspondiente certificado de pago definitivo; valoramos y agradecemos su contribución para lograr el Municipio de lo Posible.",
            icono: "exito",
          });
          var idfactura = response.data.idfactu;
          var titulo =
            response.data.statusfac === 1
              ? "Certificado de Pago Electrónico"
              : "";
          var estatus = response.data.statusfac === 1 ? "'-2'" : "0";
          var certificado = response.data.statusfac === 1 ? "true" : "false";
          var tipo = response.data.tipotran === 1 ? "Depo" : "Trans";
          window.open(
            op.reportes +
            "FACTURA=" +
            idfactura +
            "&titulo=" +
            titulo +
            "&estatus=" +
            estatus +
            "&certificado=" +
            certificado +
            "&reporte=" +
            tipo,
            "Planilla",
            "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
          );
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const chandleCheckDeuda = (item, index) => (e) => {
    e.preventDefault();
    var deu = [...deuda];
    var montoseleccionado =
      totalSelect.montoseleccionado === ""
        ? 0.0
        : totalSelect.montoseleccionado.replace(/\./g, "").replace(",", ".");
    var montoFacturadoSelect =
      totalSelect.montoFacturadoSelect === ""
        ? 0.0
        : totalSelect.montoFacturadoSelect.replace(/\./g, "").replace(",", ".");
    var interesesSelect =
      totalSelect.interesesSelect === ""
        ? 0.0
        : totalSelect.interesesSelect.replace(/\./g, "").replace(",", ".");
    var multaSelect =
      totalSelect.multaSelect === ""
        ? 0.0
        : totalSelect.multaSelect.replace(/\./g, "").replace(",", ".");
    var recargoSelect =
      totalSelect.recargoSelect === ""
        ? 0.0
        : totalSelect.recargoSelect.replace(/\./g, "").replace(",", ".");
    var retenSelect =
      totalSelect.retenSelect === ""
        ? 0.0
        : totalSelect.retenSelect.replace(/\./g, "").replace(",", ".");
    var acrediSelect =
      totalSelect.acrediSelect === ""
        ? 0.0
        : totalSelect.acrediSelect.replace(/\./g, "").replace(",", ".");
    var per =
      totalSelect.concepto === ""
        ? "Periodo(s) de Pago: "
        : totalSelect.concepto;
    var periodofac = "";
    var seleccionados =
      totalSelect.seleccionados === "" ? 0 : totalSelect.seleccionados;
    var n = 0,
      pos = 0,
      poschk = -1;
    var continua = true;

    if (espiritu === 0 && props.tipo === 0) {
      for (let i = 0; i < chkSeleccionarDeuda.current.length; i++) {
        if (chkSeleccionarDeuda.current[i].checked === true) {
          if (deu[i].nombredeuda !== deu[index].nombredeuda) {
            continua = false;
            n = 0;
            pos = -1;
            poschk = 0;
            chkSeleccionarDeuda.current[index].checked = false;
            setMensaje({
              mostrar: true,
              titulo: "Error",
              texto: "No puede facturar periodos de tipo diferentes.",
              icono: "error",
            });
            return;
          } else if (i > index) {
            for (let y = 0; y < i; y++) {
              if (deu[y].nombredeuda === deu[i].nombredeuda) {
                continua = false;
                n = 0;
                pos = -1;
                poschk = 0;
                chkSeleccionarDeuda.current[i].checked = false;
                setMensaje({
                  mostrar: true,
                  titulo: "Error",
                  texto: "Posee deuda anterior al periodo seleccionado.",
                  icono: "error",
                });
                return;
              }
            }
          }
        } else {
          if (
            deu[i].nombredeuda === deu[index].nombredeuda &&
            i < index &&
            deu[i].status === "Por Pagar"
          ) {
            continua = false;
            n = 0;
            pos = -1;
            poschk = 0;
            chkSeleccionarDeuda.current[index].checked = false;
            setMensaje({
              mostrar: true,
              titulo: "Error",
              texto: "Posee deuda anterior al periodo seleccionado.",
              icono: "error",
            });
            return;
          }
        }
      }
      if (continua) {
        for (let i = 0; i < chkSeleccionarDeuda.current.length; i++) {
          if (
            chkSeleccionarDeuda.current[i] !== null &&
            chkSeleccionarDeuda.current[i].checked === true &&
            deu[i].nombredeuda === deu[index].nombredeuda
          ) {
            pos = i;
            n = n + 1;
            if (
              pos > poschk &&
              poschk > -1 &&
              deu[poschk].nombredeuda === deu[index].nombredeuda
            ) {
              continua = false;
              n = 0;
              pos = -1;
              poschk = 0;
              if (n === 0) {
                chkSeleccionarDeuda.current[index].checked = false;
              }
            }
          } else if (
            chkSeleccionarDeuda.current[i] !== null &&
            chkSeleccionarDeuda.current[i].checked === false
          ) {
            poschk = i;
          }
        }
      }
    } else if (continua) {
      for (let i = 0; i < chkSeleccionarDeuda.current.length; i++) {
        if (
          chkSeleccionarDeuda.current[i] !== null &&
          chkSeleccionarDeuda.current[i].checked === true
        ) {
          pos = i;
          n = n + 1;
          if ((pos > poschk) & (poschk > -1)) {
            continua = false;
            n = 0;
            pos = -1;
            poschk = 0;
            if (n === 0) {
              chkSeleccionarDeuda.current[index].checked = false;
            }
          }
        } else if (
          chkSeleccionarDeuda.current[i] !== null &&
          chkSeleccionarDeuda.current[i].checked === false
        ) {
          poschk = i;
        }
      }
    }

    if (continua) {
      if (
        seleccionados + 1 > 12 &&
        chkSeleccionarDeuda.current[index].checked === true
      ) {
        chkSeleccionarDeuda.current[index].checked = false;
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "No puede facturar mas de doce periodos.",
          icono: "error",
        });
        return;
      }
      for (let i = 0; i < deu.length; i++) {
        if (
          deu[i].tipodeuda !== deu[index].tipodeuda &&
          chkSeleccionarDeuda.current[i].checked === true &&
          seleccionados >= 1
        ) {
          chkSeleccionarDeuda.current[index].checked = false;
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: "No puede facturar periodos de diferentes tipo de deuda.",
            icono: "error",
          });
          return;
        }
      }
      if (item.anio !== anioActu) {
        setDisabledAnio(true);
      } else {
        setDisabledAnio2(true);
      }

      if (item.status === "Por Pagar") {
        per = per + item.mes + " / " + item.anio + " ";
        seleccionados = seleccionados + 1;
        periodofac = periodofac + item.nummes + " / " + item.anio + " ";
        montoseleccionado =
          parseFloat(montoseleccionado) + parseFloat(item.totalperi);
        montoseleccionado =
          Math.round(montoseleccionado * Math.pow(10, 2)) / Math.pow(10, 2);
        acrediSelect = parseFloat(acrediSelect) + parseFloat(item.credito);
        acrediSelect =
          Math.round(acrediSelect * Math.pow(10, 2)) / Math.pow(10, 2);
        montoFacturadoSelect =
          parseFloat(montoFacturadoSelect) + parseFloat(item.monto);
        montoFacturadoSelect =
          Math.round(montoFacturadoSelect * Math.pow(10, 2)) / Math.pow(10, 2);
        interesesSelect =
          parseFloat(interesesSelect) + parseFloat(item.intereses);
        interesesSelect =
          Math.round(interesesSelect * Math.pow(10, 2)) / Math.pow(10, 2);
        multaSelect = parseFloat(multaSelect) + parseFloat(item.multa);
        multaSelect =
          Math.round(multaSelect * Math.pow(10, 2)) / Math.pow(10, 2);
        recargoSelect = parseFloat(recargoSelect) + parseFloat(item.recargo);
        recargoSelect =
          Math.round(recargoSelect * Math.pow(10, 2)) / Math.pow(10, 2);
        retenSelect = parseFloat(retenSelect) + parseFloat(item.retenciones);
        retenSelect =
          Math.round(retenSelect * Math.pow(10, 2)) / Math.pow(10, 2);
      } else {
        per = per.replace(item.mes + " / " + item.anio + " ", "");
        seleccionados = seleccionados - 1;
        periodofac = periodofac.replace(
          item.nummes + " / " + item.anio + " ",
          ""
        );
        montoseleccionado =
          parseFloat(montoseleccionado) - parseFloat(item.totalperi);
        montoseleccionado =
          Math.round(montoseleccionado * Math.pow(10, 2)) / Math.pow(10, 2);
        acrediSelect = parseFloat(acrediSelect) - parseFloat(item.credito);
        acrediSelect =
          Math.round(acrediSelect * Math.pow(10, 2)) / Math.pow(10, 2);
        montoFacturadoSelect =
          parseFloat(montoFacturadoSelect) - parseFloat(item.monto);
        montoFacturadoSelect =
          Math.round(montoFacturadoSelect * Math.pow(10, 2)) / Math.pow(10, 2);
        interesesSelect =
          parseFloat(interesesSelect) - parseFloat(item.intereses);
        interesesSelect =
          Math.round(interesesSelect * Math.pow(10, 2)) / Math.pow(10, 2);
        multaSelect = parseFloat(multaSelect) - parseFloat(item.multa);
        multaSelect =
          Math.round(multaSelect * Math.pow(10, 2)) / Math.pow(10, 2);
        recargoSelect = parseFloat(recargoSelect) - parseFloat(item.recargo);
        recargoSelect =
          Math.round(recargoSelect * Math.pow(10, 2)) / Math.pow(10, 2);
        retenSelect = parseFloat(retenSelect) - parseFloat(item.retenciones);
        retenSelect =
          Math.round(retenSelect * Math.pow(10, 2)) / Math.pow(10, 2);
      }

      if (item.status === "Por Pagar") {
        item.status = "Listo";
        setDisponiblesDeuda(disponiblesDeuda - 1);
      } else if (item.status === "Listo") {
        item.status = "Por Pagar";
        setDisponiblesDeuda(disponiblesDeuda + 1);
      }

      deu[index] = item;

      setDeuda(deu);

      setTotalSelect({
        concepto: per,
        seleccionados: seleccionados,
        montoseleccionado: formatMoneda(
          montoseleccionado.toString().replace(".", ","),
          ",",
          ".",
          2
        ),
        acrediSelect: formatMoneda(
          acrediSelect.toString().replace(".", ","),
          ",",
          ".",
          2
        ),
        montoFacturadoSelect: formatMoneda(
          montoFacturadoSelect.toString().replace(".", ","),
          ",",
          ".",
          2
        ),
        interesesSelect: formatMoneda(
          interesesSelect.toString().replace(".", ","),
          ",",
          ".",
          2
        ),
        multaSelect: formatMoneda(
          multaSelect.toString().replace(".", ","),
          ",",
          ".",
          2
        ),
        recargoSelect: formatMoneda(
          recargoSelect.toString().replace(".", ","),
          ",",
          ".",
          2
        ),
        retenSelect: formatMoneda(
          retenSelect.toString().replace(".", ","),
          ",",
          ".",
          2
        ),
      });
      if (seleccionados > 0) {
        setBtnDisabled(false);
        setDisabledMulta(true);
      } else {
        setBtnDisabled(true);
        setDisabledMulta(false);
        setDisabledAnio(false);
        setDisabledAnio2(false);
        setTotalSelect({
          concepto: "",
          seleccionados: "",
          montoseleccionado: "",
          acrediSelect: "",
          montoFacturadoSelect: "",
          interesesSelect: "",
          multaSelect: "",
          recargoSelect: "",
          retenSelect: "",
        });
      }
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Posee deuda anterior al periodo seleccionado.",
        icono: "error",
      });
    }
  };

  const procesarPagoWeb = () => {
    var nAnio = [];
    var nMes = [];
    var nMonto = [];
    var nInteres = [];
    var nMulta = [];
    var nRecargo = [];
    var nTotal = [];
    var cIdFact = [];
    var cNumPlani = [];
    var cPeri = [];
    var tdeu = [];
    var iddeu = [];
    var tipod = [];

    if (disabledMulta) {
      for (let i = 0; i < deuda.length; i++) {
        var sigue = deuda[i].status;
        if (sigue === "Listo") {
          nAnio.push(deuda[i].anio);
          nMes.push(deuda[i].nummes);
          nMonto.push(deuda[i].monto);
          nInteres.push(deuda[i].intereses);
          nMulta.push(deuda[i].multa);
          nRecargo.push(deuda[i].recargo);
          nTotal.push(deuda[i].totalperi);
          cIdFact.push(deuda[i].idfact);
          cNumPlani.push(deuda[i].planilla);
          cPeri.push(deuda[i].periodo);
          tdeu.push(deuda[i].tipodeuda);
          iddeu.push(parseInt(deuda[i].iddeu));
          tipod.push(deuda[i].tipod);
        }
      }
    } else {
      for (let i = 0; i < multa.length; i++) {
        var sigue = multa[i].status;
        if (sigue === "Listo") {
          nAnio.push(multa[i].anio);
          nMes.push(multa[i].nummes);
          nMonto.push(multa[i].monto);
          nInteres.push(multa[i].intereses);
          nMulta.push(multa[i].multa);
          nRecargo.push(multa[i].recargo);
          nTotal.push(multa[i].totalperi);
          cIdFact.push(multa[i].idfact);
          cNumPlani.push(multa[i].planilla);
          cPeri.push(multa[i].periodo);
          tdeu.push(multa[i].tipodeuda);
          iddeu.push(parseInt(multa[i].iddeu));
          tipod.push(multa[i].tipod);
        }
      }
    }

    var tipPago = tipoPago === "deposito" ? 1 : 2;

    var body = {
      idcontri: idcontribuyente,
      fechasis: fechaSistema,
      idimpu: tabla && tabla.idtipoimpuesto,
      mont: totalSelect.montoseleccionado.replace(/\./g, "").replace(",", "."),
      tipo: tipPago,
      cuenta: cuentasBanca,
      totaldescuento: "0.00",
      txtfecha1:
        fechaD1 === "" ? fechaD1 : moment.utc(fechaD1).format("YYYY-MM-DD"),
      txtnumdepo1: numeroD1,
      txtmontoefec1: efectivo1.replace(/\./g, "").replace(",", "."),
      txtfecha2:
        fechaD2 === "" ? fechaD2 : moment.utc(fechaD2).format("YYYY-MM-DD"),
      txtnumdepo2: numeroD2,
      txtmontoefec2: efectivo2.replace(/\./g, "").replace(",", "."),
      txtfechatran1:
        fechaT1 === "" ? fechaT1 : moment.utc(fechaT1).format("YYYY-MM-DD"),
      txtnumtran1: numeroT1,
      bcliente1: banCliT1,
      txtmontotran1: montoT1.replace(/\./g, "").replace(",", "."),
      txtfechatran2:
        fechaT2 === "" ? fechaT2 : moment.utc(fechaT2).format("YYYY-MM-DD"),
      txtnumtran2: numeroT2,
      bcliente2: banCliT2,
      txtmontotran2: montoT2.replace(/\./g, "").replace(",", "."),
      txtfechatran3:
        fechaT3 === "" ? fechaT3 : moment.utc(fechaT3).format("YYYY-MM-DD"),
      txtnumtran3: numeroT3,
      bcliente3: banCliT3,
      txtmontotran3: montoT3.replace(/\./g, "").replace(",", "."),
      ctotmonto: totalSelect.montoFacturadoSelect
        .replace(/\./g, "")
        .replace(",", "."),
      ctotint: totalSelect.interesesSelect.replace(/\./g, "").replace(",", "."),
      ctotrec: totalSelect.recargoSelect.replace(/\./g, "").replace(",", "."),
      ctotmulta: totalSelect.multaSelect.replace(/\./g, "").replace(",", "."),
      ctotrete: totalSelect.retenSelect.replace(/\./g, "").replace(",", "."),
      txtconcepto: totalSelect.concepto,
      panio: nAnio,
      pmes: nMes,
      pmonto: nMonto,
      pinteres: nInteres,
      pmulta: nMulta,
      precargo: nRecargo,
      ptotal: nTotal,
      tdeu,
      iddeu,
      tipod,
    };

    procesarpago(body);
  };

  const handleCloseSi = () => {
    procesarPagoWeb();
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const blanquear = () => {
    setMulta([]);
    setDeuda([]);
    setDisponiblesDeuda(0);
    setBtnDisabled(true);
    setDisabledMulta(false);
    setDisabledDeuda(false);
    setDisabledAnio(false);
    setDisabledAnio2(false);
    setCuentasBanca("0");
    setTipoPago("");
    setEfectivo1("0,00");
    setFechaD1("");
    setNumeroD1("");
    setEfectivo2("0,00");
    setFechaD2("");
    setNumeroD2("");
    setFechaT1("");
    setNumeroT1("");
    setBanCliT1("0");
    setMontoT1("0,00");
    setFechaT2("");
    setNumeroT2("");
    setBanCliT2("0");
    setMontoT2("0,00");
    setFechaT3("");
    setNumeroT3("");
    setBanCliT3("0");
    setMontoT3("0,00");
    setTotalSelect({
      concepto: "",
      seleccionados: "",
      montoseleccionado: "",
      acrediSelect: "",
      montoFacturadoSelect: "",
      interesesSelect: "",
      multaSelect: "",
      recargoSelect: "",
      retenSelect: "",
    });
  };

  const imprimirPago = (index) => (event) => {
    event.preventDefault();
    var idfactura = deuda[index].idfac;
    var titulo =
      deuda[index].estatusfac === 1 ? "Certificado de Pago Electrónico" : "";
    var estatus = deuda[index].estatusfac === 1 ? "'-2'" : "0";
    var certificado = deuda[index].estatusfac === 1 ? "true" : "false";
    var tipo = deuda[index].tipotransaccion === 1 ? "Depo" : "Trans";

    window.open(
      op.reportes +
      "FACTURA=" +
      idfactura +
      "&titulo=" +
      titulo +
      "&estatus=" +
      estatus +
      "&certificado=" +
      certificado +
      "&reporte=" +
      tipo,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const handleCatalogo = () => {
    switch (props.tipo) {
      case 0:
        if (!catalogoC) {
          setCatalogoC(true);
        } else {
          setCatalogoC(false);
        }
        break;
      case 1:
        if (!catalogoI) {
          setCatalogoI(true);
        } else {
          setCatalogoI(false);
        }
        break;
      case 2:
        if (!catalogoV) {
          setCatalogoV(true);
        } else {
          setCatalogoV(false);
        }
        break;
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
        if (!catalogoA) {
          setCatalogoA(true);
        } else {
          setCatalogoA(false);
        }
        break;
      /*case 5:
        if (!catalogoM) {
          setCatalogoM(true);
        } else {
          setCatalogoM(false);
        }
        break;*/
      /*case 6:
        if (!catalogoL) {
          setCatalogoL(true);
        } else {
          setCatalogoL(false);
        }
        break;*/
      /*case 7:
        if (!catalogoE) {
          setCatalogoE(true);
        } else {
          setCatalogoE(false);
        }
        break;*/
      default:
        break;
    }
  };

  const handleAceptaCatalogo = (id) => {
    switch (props.tipo) {
      case 0:
        setCatalogoC(false);
        //datosContribuyente(id);
        break;
      case 1:
        setCatalogoI(false);
        break;
      case 2:
        setCatalogoV(false);
        break;
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
        setCatalogoA(false);
        break;
      /*case 5:
        setCatalogoM(false);
        break;*/
      /*case 6:
        setCatalogoL(false);
        break;*/
      /*case 7:
        setCatalogoE(false);
        break;*/
      default:
        break;
    }
    datosContribuyente(id);
    //setValuess({ ...valuess, idcontribuyente: idcontri, nombre: nombage, rif: rif, direccion: direccion });
  };

  const datosContribuyente = (idcontri) => {
    let nomid = "";
    let nomtab = "";
    let tipo = 1;
    let tipotabla = 0;
    let codimpu = 0;
    let idinmue = 0;
    setIdComercio(0);
    switch (props.tipo) {
      case 0:
        tipo = 1;
        setNomTablaContri("comercio");
        setNomTablaDeuda("deudacomercio");
        nomtab = "comercio";
        nomid = "idcomercio";
        break;
      case 1:
        tipo = 1;
        setNomTablaContri("inmueble");
        setNomTablaDeuda("deudainmueble");
        nomtab = "inmueble";
        nomid = "idinmueble";
        break;
      case 2:
        tipo = 1;
        setNomTablaContri("vehiculo");
        setNomTablaDeuda("deudavehiculo");
        nomtab = "vehiculo";
        nomid = "idvehiculo";
        break;
      case 3:
        tipo = 1;
        setNomTablaContri("comercio");
        setNomTablaDeuda("deudaapuesta");
        nomtab = "comercio";
        nomid = "idcomercio";
        break;
      case 4:
        setCodImpu(3);
        codimpu = 3;
        tipo = 3;
        setNomTablaContri("rentasinmobiliarias");
        setNomTablaDeuda("deudarentas");
        nomtab = "rentasinmobiliarias";
        nomid = "idrentas";
        break;
      case 5:
        setCodImpu(0);
        codimpu = 0;
        tipo = 2;
        setNomTablaContri("rentasinmobiliarias");
        setNomTablaDeuda("deudarentas");
        nomtab = "rentasinmobiliarias";
        nomid = "idrentas";
        break;
      case 6:
        setCodImpu(2);
        codimpu = 2;
        tipo = 2;
        setNomTablaContri("rentasinmobiliarias");
        setNomTablaDeuda("deudarentas");
        nomtab = "rentasinmobiliarias";
        nomid = "idrentas";
        break;
      case 7:
        setCodImpu(1);
        codimpu = 1;
        tipo = 3;
        setNomTablaContri("rentasinmobiliarias");
        setNomTablaDeuda("deudarentas");
        nomtab = "rentasinmobiliarias";
        nomid = "idrentas";
        break;
      case 8:
        setCodImpu(4);
        codimpu = 4;
        tipo = 1;
        setNomTablaContri("rentasinmobiliarias");
        setNomTablaDeuda("deudarentas");
        nomtab = "rentasinmobiliarias";
        nomid = "idrentas";
        break;
      case 9:
        setCodImpu(5);
        codimpu = 5;
        tipo = 3;
        setNomTablaContri("rentasinmobiliarias");
        setNomTablaDeuda("deudarentas");
        nomtab = "rentasinmobiliarias";
        nomid = "idrentas";
        break;
    }

    let endpoint;
    let campos = "*";
    if (tipo == 1 || tipo == 3) {
      endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idcontri}&nomtab=${nomtab}&nomid=${nomid}`;
    } /*else if (tipo == 2) {
      let nomid2 = 'codigoimpuesto';
      let id2 = codimpu;
      endpoint = `${op.conexion}/api/consulta/modeli22?campos=${campos}&id=${idcontri}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${id2}`;
    } */ else {
      let nomid2 = "codigoimpuesto";
      let id2 = codimpu;
      let nomtab2 = "inmueble";
      let nomid3 = "idinmueble";
      endpoint = `${op.conexion}/api/consulta/modeli22?campos=${campos}&id=${idcontri}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${id2}&nomtab2=${nomtab2}&nomid3=${nomid3}`;
    }

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            switch (props.tipo) {
              case 0:
                txtContribuyente.current.value = response.data.idcomercio;
                valuess.rif = response.data.rif;
                valuess.nombre = response.data.nombre;
                valuess.direccion = response.data.direccion;
                if (op.agylsoft) {
                  apiagylsoft(response.data);
                } else {
                  SelectDeudaC(
                    txtContribuyente.current.value,
                    fechaSistema,
                    espiritu
                  );
                }

                break;
              case 1:
                txtContribuyente.current.value = response.data.idinmueble;
                valuess.rif =
                  response.data.cedulapropie === null
                    ? ""
                    : response.data.cedulapropie.trim();
                valuess.nombre =
                  response.data.nombrepropie === null
                    ? ""
                    : response.data.nombrepropie.trim();
                valuess.direccion =
                  (response.data.dirinmue1 == null
                    ? ""
                    : response.data.dirinmue1.trim().toLowerCase() === "null"
                      ? ""
                      : response.data.dirinmue1.trim().toLowerCase() === ""
                        ? ""
                        : response.data.dirinmue1 !== null
                          ? response.data.dirinmue1.trim()
                          : "") +
                  " " +
                  (response.data.descridirinmue1 === null
                    ? ""
                    : response.data.descridirinmue1.trim().toLowerCase() ===
                      "null"
                      ? ""
                      : response.data.descridirinmue1.trim().toLowerCase() === ""
                        ? ""
                        : response.data.descridirinmue1 !== null
                          ? response.data.descridirinmue1.trim()
                          : "") +
                  " " +
                  (response.data.dirinmue2 === null
                    ? ""
                    : response.data.dirinmue2.trim().toLowerCase() === "null"
                      ? ""
                      : response.data.dirinmue2.trim().toLowerCase() === ""
                        ? ""
                        : response.data.dirinmue2 !== null
                          ? response.data.dirinmue2.trim()
                          : "") +
                  " " +
                  (response.data.descridirinmue2 === null
                    ? ""
                    : response.data.descridirinmue2.trim().toLowerCase() ===
                      "null"
                      ? ""
                      : response.data.descridirinmue2.trim().toLowerCase() === ""
                        ? ""
                        : response.data.descridirinmue2 !== null
                          ? response.data.descridirinmue2.trim()
                          : "") +
                  " " +
                  (response.data.ubicacionterreno === null
                    ? ""
                    : !response.data.ubicacionterreno.trim() === "ESQUINA"
                      ? (response.data.dirinmue3 === null
                        ? ""
                        : response.data.dirinmue3.trim().toLowerCase() ===
                          "null"
                          ? ""
                          : response.data.dirinmue3.trim().toLowerCase() === ""
                            ? ""
                            : response.data.dirinmue3 !== null
                              ? " ENTRE" + " " + response.data.dirinmue3.trim()
                              : "") +
                      " " +
                      (response.data.descridirinmue3 === null
                        ? ""
                        : response.data.descridirinmue3.trim().toLowerCase() ===
                          "null"
                          ? ""
                          : response.data.descridirinmue3.trim().toLowerCase() ===
                            ""
                            ? ""
                            : response.data.descridirinmue3 !== null
                              ? response.data.descridirinmue3.trim()
                              : "") +
                      " " +
                      (response.data.dirinmue4 === null
                        ? ""
                        : response.data.dirinmue4.trim().toLowerCase() ===
                          "null"
                          ? ""
                          : response.data.dirinmue4.trim().toLowerCase() === ""
                            ? ""
                            : response.data.dirinmue4 !== null
                              ? "Y" + " " + response.data.dirinmue4.trim()
                              : "") +
                      " " +
                      (response.data.descridirinmue4 === null
                        ? ""
                        : response.data.descridirinmue4.trim() === "null"
                          ? ""
                          : response.data.descridirinmue4.trim().toLowerCase() ===
                            "null"
                            ? ""
                            : response.data.descridirinmue4.trim().toLowerCase() ===
                              ""
                              ? ""
                              : response.data.descridirinmue4 !== null
                                ? response.data.descridirinmue4.trim()
                                : "") +
                      " "
                      : (response.data.dirinmue3 === null
                        ? ""
                        : response.data.dirinmue3.trim().toLowerCase() ===
                          "null"
                          ? ""
                          : response.data.dirinmue3.trim().toLowerCase() === ""
                            ? ""
                            : response.data.dirinmue3 !== null
                              ? " ESQUINA" + " " + response.data.dirinmue3.trim()
                              : "") +
                      " " +
                      (response.data.descridirinmue3 === null
                        ? ""
                        : response.data.descridirinmue3.trim().toLowerCase() ===
                          "null"
                          ? ""
                          : response.data.descridirinmue3.trim().toLowerCase() ===
                            ""
                            ? ""
                            : response.data.descridirinmue3 !== null
                              ? response.data.descridirinmue3.trim()
                              : "") +
                      " ") +
                  (response.data.dirinmue5 === null
                    ? ""
                    : response.data.dirinmue5.trim().toLowerCase() === "null"
                      ? ""
                      : response.data.dirinmue5.trim().toLowerCase() === ""
                        ? ""
                        : response.data.dirinmue5 !== null
                          ? response.data.dirinmue5.trim()
                          : "") +
                  " " +
                  (response.data.descridirinmue5 === null
                    ? ""
                    : response.data.descridirinmue5.trim().toLowerCase() ===
                      "s/nombre"
                      ? ""
                      : response.data.descridirinmue5.trim().toLowerCase() === ""
                        ? ""
                        : response.data.descridirinmue5 !== null
                          ? response.data.descridirinmue5.trim()
                          : ""
                  ).trim() +
                  " " +
                  (response.data.numcivicoinmue === null
                    ? ""
                    : response.data.numcivicoinmue.trim().toLowerCase() ===
                      "s/n"
                      ? ""
                      : response.data.numcivicoinmue.trim().toLowerCase() === ""
                        ? ""
                        : response.data.numcivicoinmue !== null
                          ? " Nº" + " " + response.data.numcivicoinmue.trim()
                          : "");
                SelectDeuda(txtContribuyente.current.value);

                SelectIdComercioFact(response.data.idinmueble);
                break;
              case 2:
                txtContribuyente.current.value = response.data.idvehiculo;
                valuess.nombre =
                  response.data.nombrepropie === null
                    ? ""
                    : response.data.nombrepropie.trim();
                valuess.direccion =
                  response.data.direccionpropie === null
                    ? ""
                    : response.data.direccionpropie.trim();
                valuess.rif =
                  response.data.cedulapropie === null
                    ? ""
                    : response.data.cedulapropie.trim();
                SelectDeuda(txtContribuyente.current.value);
                break;
              case 3:
              case 9:
                txtContribuyente.current.value = response.data.idcomercio;
                valuess.rif = response.data.rif;
                valuess.nombre = response.data.nombre;
                valuess.direccion = response.data.direccion;
                setIdComercio(response.data.idcomercio);
                SelectDeudaC(
                  txtContribuyente.current.value,
                  fechaSistema,
                  espiritu
                );
                break;
              case 4:
              case 7:
              case 8:
                txtContribuyente.current.value = response.data.idrentas;
                valuess.nombre =
                  response.data.nombrearrendatario === null
                    ? ""
                    : response.data.nombrearrendatario.trim();
                valuess.direccion =
                  response.data.direccion === null
                    ? ""
                    : response.data.direccion.trim();
                valuess.rif =
                  response.data.cedrif === null
                    ? ""
                    : response.data.cedrif.trim();
                tipotabla = response.data.tipotabla;
                idinmue = response.data.idinmueble;
                SelectDeuda(txtContribuyente.current.value);
                if (response.data.tipotabla === 1) {
                  setIdComercio(response.data.idinmueble);
                } else {
                  SelectIdComercioFact(response.data.idrentas);
                }
                break;
              case 5:
              case 6:
                txtContribuyente.current.value = response.data.idrentas;
                valuess.nombre =
                  response.data.nombrearrendatario === null
                    ? ""
                    : response.data.nombrearrendatario.trim();
                valuess.direccion =
                  (response.data.dirinmue1 == null
                    ? ""
                    : response.data.dirinmue1.trim().toLowerCase() === "null"
                      ? ""
                      : response.data.dirinmue1.trim().toLowerCase() === ""
                        ? ""
                        : response.data.dirinmue1 !== null
                          ? response.data.dirinmue1.trim()
                          : "") +
                  " " +
                  (response.data.descridirinmue1 === null
                    ? ""
                    : response.data.descridirinmue1.trim().toLowerCase() ===
                      "null"
                      ? ""
                      : response.data.descridirinmue1.trim().toLowerCase() === ""
                        ? ""
                        : response.data.descridirinmue1 !== null
                          ? response.data.descridirinmue1.trim()
                          : "") +
                  " " +
                  (response.data.dirinmue2 === null
                    ? ""
                    : response.data.dirinmue2.trim().toLowerCase() === "null"
                      ? ""
                      : response.data.dirinmue2.trim().toLowerCase() === ""
                        ? ""
                        : response.data.dirinmue2 !== null
                          ? response.data.dirinmue2.trim()
                          : "") +
                  " " +
                  (response.data.descridirinmue2 === null
                    ? ""
                    : response.data.descridirinmue2.trim().toLowerCase() ===
                      "null"
                      ? ""
                      : response.data.descridirinmue2.trim().toLowerCase() === ""
                        ? ""
                        : response.data.descridirinmue2 !== null
                          ? response.data.descridirinmue2.trim()
                          : "") +
                  " " +
                  (response.data.ubicacionterreno === null
                    ? ""
                    : !response.data.ubicacionterreno.trim() === "ESQUINA"
                      ? (response.data.dirinmue3 === null
                        ? ""
                        : response.data.dirinmue3.trim().toLowerCase() ===
                          "null"
                          ? ""
                          : response.data.dirinmue3.trim().toLowerCase() === ""
                            ? ""
                            : response.data.dirinmue3 !== null
                              ? " ENTRE" + " " + response.data.dirinmue3.trim()
                              : "") +
                      " " +
                      (response.data.descridirinmue3 === null
                        ? ""
                        : response.data.descridirinmue3.trim().toLowerCase() ===
                          "null"
                          ? ""
                          : response.data.descridirinmue3.trim().toLowerCase() ===
                            ""
                            ? ""
                            : response.data.descridirinmue3 !== null
                              ? response.data.descridirinmue3.trim()
                              : "") +
                      " " +
                      (response.data.dirinmue4 === null
                        ? ""
                        : response.data.dirinmue4.trim().toLowerCase() ===
                          "null"
                          ? ""
                          : response.data.dirinmue4.trim().toLowerCase() === ""
                            ? ""
                            : response.data.dirinmue4 !== null
                              ? "Y" + " " + response.data.dirinmue4.trim()
                              : "") +
                      " " +
                      (response.data.descridirinmue4 === null
                        ? ""
                        : response.data.descridirinmue4.trim() === "null"
                          ? ""
                          : response.data.descridirinmue4.trim().toLowerCase() ===
                            "null"
                            ? ""
                            : response.data.descridirinmue4.trim().toLowerCase() ===
                              ""
                              ? ""
                              : response.data.descridirinmue4 !== null
                                ? response.data.descridirinmue4.trim()
                                : "") +
                      " "
                      : (response.data.dirinmue3 === null
                        ? ""
                        : response.data.dirinmue3.trim().toLowerCase() ===
                          "null"
                          ? ""
                          : response.data.dirinmue3.trim().toLowerCase() === ""
                            ? ""
                            : response.data.dirinmue3 !== null
                              ? " ESQUINA" + " " + response.data.dirinmue3.trim()
                              : "") +
                      " " +
                      (response.data.descridirinmue3 === null
                        ? ""
                        : response.data.descridirinmue3.trim().toLowerCase() ===
                          "null"
                          ? ""
                          : response.data.descridirinmue3.trim().toLowerCase() ===
                            ""
                            ? ""
                            : response.data.descridirinmue3 !== null
                              ? response.data.descridirinmue3.trim()
                              : "") +
                      " ") +
                  (response.data.dirinmue5 === null
                    ? ""
                    : response.data.dirinmue5.trim().toLowerCase() === "null"
                      ? ""
                      : response.data.dirinmue5.trim().toLowerCase() === ""
                        ? ""
                        : response.data.dirinmue5 !== null
                          ? response.data.dirinmue5.trim()
                          : "") +
                  " " +
                  (response.data.descridirinmue5 === null
                    ? ""
                    : response.data.descridirinmue5.trim().toLowerCase() ===
                      "s/nombre"
                      ? ""
                      : response.data.descridirinmue5.trim().toLowerCase() === ""
                        ? ""
                        : response.data.descridirinmue5 !== null
                          ? response.data.descridirinmue5.trim()
                          : ""
                  ).trim() +
                  " " +
                  (response.data.numcivicoinmue === null
                    ? ""
                    : response.data.numcivicoinmue.trim().toLowerCase() ===
                      "s/n"
                      ? ""
                      : response.data.numcivicoinmue.trim().toLowerCase() === ""
                        ? ""
                        : response.data.numcivicoinmue !== null
                          ? " Nº" + " " + response.data.numcivicoinmue.trim()
                          : "");
                valuess.rif =
                  response.data.cedrif === null
                    ? ""
                    : response.data.cedrif.trim();
                tipotabla = response.data.tipotabla;
                idinmue = response.data.idinmueble;
                SelectDeuda(txtContribuyente.current.value);
                if (response.data.tipotabla === 1) {
                  setIdComercio(response.data.idinmueble);
                } else {
                  SelectIdComercioFact(response.data.idrentas);
                }
                break;
            }
            setDisabledId(true);
          } else {
            setActivate(false);
            setDisabledId(false);
            setTimeout(() => {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El Contribuyente no existe...",
                icono: "error",
              });
              txtContribuyente.current.value = "";
              valuess.rif = "";
              valuess.nombre = "";
              valuess.direccion = "";
              blanquear();
              txtContribuyente.current.focus();
            }, 100);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const apiagylsoft = (contri) => {
    setActivate(true);
    let endpoint = `${op.conexion
      }/api/agylsoft/agylsoft?rif=${contri.rif.trim()}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.number_contracts > 0) {
            let contratos = response.data.contracts;
            let contracts = [];
            let tiene = false;
            let mesdesde = 0;
            let aniodesde = 0;

            let meshasta = 0;
            let aniohasta = 0;
            let num = 0;
            for (let i = 0; i < contratos.length; i++) {
              if (contratos[i].since !== false) {
                mesdesde = parseInt(contratos[i].since.split("-")[0]);
                aniodesde = parseInt(contratos[i].since.split("-")[1]);

                meshasta = parseInt(contratos[i].until.split("-")[0]);
                aniohasta = parseInt(contratos[i].until.split("-")[1]);
                num = 0;

                if (aniodesde === aniohasta) {
                  for (let x = mesdesde; x <= meshasta; x++) {
                    num = num + 1;
                  }
                } else {
                  for (let j = aniodesde; j <= aniohasta; j++) {
                    if (aniodesde === j) {
                      for (let x = mesdesde; x <= 12; x++) {
                        num = num + 1;
                      }
                    } else if (aniohasta === j) {
                      for (let x = 1; x <= meshasta; x++) {
                        num = num + 1;
                      }
                    } else {
                      for (let x = 1; x <= 12; x++) {
                        num = num + 1;
                      }
                    }
                  }
                }
              }

              if (num >= 3) {
                tiene = true;
                contracts.push(contratos[i]);
              }
            }

            if (tiene) {
              setAgyl({
                number: 2,
                contracts: contracts,
                show: true,
              });
            } else {
              setAgyl({
                number: 0,
                contracts: [],
                show: false,
              });
            }
          } else if (response.data.number_contracts === 0) {
            setAgyl({
              number: 1,
              contracts: response.data.contracts,
              show: true,
            });
          } else {
            setAgyl({
              number: 0,
              contracts: [],
              show: false,
            });
          }
        }
      })
      .finally(() => {
        SelectDeudaC(txtContribuyente.current.value, fechaSistema, espiritu);
      });
  };

  const validarContribuyente = (event) => {
    event.preventDefault();
    (valuess.idcontribuyente = event.target.value),
      (valuess.nombre = ""),
      (valuess.rif = ""),
      (valuess.direccion = "");
    //setDeuda([]);
    chkSeleccionarDeuda.current = [];

    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        datosContribuyente(event.target.value);
      } else {
        txtContribuyente.current.value = "";
      }
    }
  };

  const cancelar = (e) => {
    e.preventDefault();
    valuess.idcontribuyente = "";
    valuess.rif = "";
    valuess.nombre = "";
    valuess.direccion = "";
    setDisabledId(false);
    props.onHideCancela();
    blanquear();
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var factu = [];
    var factudet = [];
    var anioDeu = parseInt(0);
    var idDeu = parseInt(0);
    var idcontri = parseInt(txtContribuyente.current.value, 10);
    var idingre = idTipIngre;
    var nomTabDeuda = nomTablaDeuda;
    var nomTabContri = nomTablaContri;
    if (espiritu === 0) {
      for (let i = 0; i < deuda.length; i++) {
        if (deuda[i].status === "Listo") {
          if (deuda[i].nombredeuda === "deudacomercio") {
            idingre = idTipIngre;
          } else if (deuda[i].nombredeuda === "deudarentas") {
            idingre = idTipIngreRS;
            nomTabDeuda = "deudarentas";
            nomTabContri = "rentasinmobiliarias";
            idcontri = idRenta;
          }
          break;
        }
      }
    }
    if (!disabledDeuda) {
      for (let i = 0; i < deuda.length; i++) {
        if (deuda[i].status === "Listo") {
          anioDeu = deuda[i].anio;
          factudet.push({
            montoimpuesto: deuda[i].monto,
            montorecargo: deuda[i].recargo,
            montointeres: deuda[i].intereses,
            periodo: deuda[i].nummes + "/" + deuda[i].anio,
            montomulta: deuda[i].multa,
            iddeuda: deuda[i].iddeu,
            montopetro: deuda[i].monto / factorCambio,
            tipodeuda: deuda[i].tipodeuda,
          });
        }
      }

      factu.push({
        totalinmpuesto: totalSelect.montoFacturadoSelect
          .replace(/\./g, "")
          .replace(",", "."),
        totalrecargo: totalSelect.recargoSelect
          .replace(/\./g, "")
          .replace(",", "."),
        totalinteres: totalSelect.interesesSelect
          .replace(/\./g, "")
          .replace(",", "."),
        idtipoingreso: idingre,
        fechaemision: fechaSistema,
        descripcion: totalSelect.concepto + " " + tipoImpu,
        tablacontribuyente: nomTabContri,
        tabladeuda: nomTabDeuda,
        iddeuda: 0,
        status: 0,
        nombrecontri: valuess.nombre,
        direccioncontri: valuess.direccion,
        cedrif: valuess.rif,
        totalmulta: totalSelect.multaSelect
          .replace(/\./g, "")
          .replace(",", "."),
        deducible:
          parseFloat(
            totalSelect.retenSelect.replace(/\./g, "").replace(",", ".")
          ) +
          parseFloat(
            totalSelect.acrediSelect.replace(/\./g, "").replace(",", ".")
          ),
        facturador: idusuario,
        idcomercio: idComercio,
      });
    }

    let body = {
      idcontri: parseInt(idcontri),
      factu: JSON.stringify(factu),
      factudet: JSON.stringify(factudet),
      nomtab: nomTabla,
      tipoimpu: tipoImpu,
      idingremul: idTipIngreMulta,
    };

    procesarFactura(body);
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setFactorCambio(props.factorCambio);
        switch (props.tipo) {
          case 0:
            setNomTabla("comercio");
            setTipoImpu("ACTIVIDADES ECONOMICAS");
            break;
          case 1:
            setNomTabla("inmueble");
            setTipoImpu("INMUEBLES URBANOS");
            break;
          case 2:
            setNomTabla("vehiculo");
            setTipoImpu("IMPUESTOS DE VEHICULOS");
            break;
          case 3:
            setNomTabla("comercio");
            setTipoImpu("APUESTAS LICITAS");
            break;
          case 4:
            setCodImpu(3);
            setNomTabla("rentasinmobiliarias");
            setTipoImpu("RENTAS INMOBILIARIAS");
            break;
          case 5:
            setCodImpu(0);
            setNomTabla("rentasinmobiliarias");
            setTipoImpu("RENTAS INMOBILIARIAS");
            break;
          case 6:
            setCodImpu(2);
            setNomTabla("rentasinmobiliarias");
            setTipoImpu("RENTAS INMOBILIARIAS");
            break;
          case 7:
            setCodImpu(1);
            setNomTabla("rentasinmobiliarias");
            setTipoImpu("RENTAS INMOBILIARIAS");
            break;
          case 8:
            setCodImpu(4);
            setNomTabla("rentasinmobiliarias");
            setTipoImpu("RENTAS INMOBILIARIAS");
            break;
          case 9:
            setCodImpu(5);
            setNomTabla("rentasinmobiliarias");
            setTipoImpu("RENTAS INMOBILIARIAS");
            break;
        }
        seleccionartipoIngreso();
        seleccionartipoIngresoMulta();
        seleccionartipoIngresoRS();
        seleccionarValorPetro();
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
        <h3 className="fw-bold m-0">{props.tipoImpuesto}</h3>
        <a type="button" className="text-light fs-6 fw-bold" onClick={cancelar}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="">
        <div className="col-md-12 row mx-auto px-0 ">
          <span className="fw-bold rounded p-2 col-md-2 text-center border-table rounded">
            Valor Euro:
            <span className="fs-5">
              {" €" +
                formatMoneda(
                  factorCambio.toString().replace(",", "").replace(".", ","),
                  ",",
                  ".",
                  2
                )}
            </span>
          </span>
          <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap align-items-center justify-content-between">
            <legend className="float-none m-0 w-auto">
              Datos del Contribuyente
            </legend>
            <div className="col-3 m-0 p-0">
              <SearchInput label="Código:"
                name="idcontribuyente"
                autoComplete="off"
                ref={txtContribuyente}
                disabled={disabledId}
                defaultValue={valuess.idcontribuyente}
                onKeyUp={validarContribuyente}
                placeholder="Código"
                onChange={onChange}
                onClickButton={handleCatalogo}
              />
            </div>
            <div className="col-4 m-0 p-0">
              <Input label="Nombres:"
                disabled
                autoComplete="off"
                value={valuess.nombre}
                name="nombre"
              />
            </div>
            <div className="col-4 m-0 p-0">
              <Input label="Cédula/Rif:"
                disabled
                autoComplete="off"
                value={valuess.rif}
                name="rif"
              />
            </div>
            <div className="col-12 m-0 mt-2 p-0">
              <Textarea label='Dirección:'
                style={{ height: 70 }}
                disabled
                autoComplete="off"
                value={valuess.direccion}
                name="direccion"
              />
            </div>
          </fieldset>
          <fieldset className="col-12 m-0 p-2 border-azul rounded">
            <legend className="float-none m-0 w-auto">Datos de la Deuda</legend>
            <TblContainer
              container={{ maxHeight: 180, width: "100%", overflow: "auto", marginBottom: 0 }}
            >
              <TblHead />
              <tbody>
                {deuda &&
                  deuda.map((deu, index) => (
                    <tr key={index}>
                      {deu.status === "Por Pagar" ? (
                        <td className="p-0 text-center letra-tabla-td">
                          <input
                            type="checkbox"
                            disabled={
                              /* tabla && tabla.tabla === '1x500' ? (index > 0 ? true : false) : */ tabla &&
                                tabla.tabla === "1x500" &&
                                deuda.length !== disponiblesDeuda
                                ? true
                                : deu.anio === anioActu
                                  ? disabledAnio
                                  : disabledAnio2
                                    ? true
                                    : disabledDeuda
                            }
                            ref={(el) =>
                              (chkSeleccionarDeuda.current[index] = el)
                            }
                            defaultChecked={
                              deu.status === "Por Pagar" ? false : true
                            }
                            onClick={chandleCheckDeuda(deu, index)}
                            name={"chk" + deu.mes + deu.anio}
                            style={{ width: 20, height: 20 }}
                          />
                        </td>
                      ) : (
                        <td className="p-0 text-center letra-tabla-td">
                          <input
                            type="checkbox"
                            ref={(el) =>
                              (chkSeleccionarDeuda.current[index] = el)
                            }
                            defaultChecked={true}
                            name={"chk" + deu.mes + deu.anio}
                            onClick={chandleCheckDeuda(deu, index)}
                            style={{
                              width: 20,
                              height: 20,
                            }} /* disabled={( deu.status === 'Listo' && ((tabla && tabla.tabla==='1x500') || ((deuda.length - disponiblesDeuda) === index + 1))) ? false : true} */
                          />
                        </td>
                      )}
                      <td className="p-0 text-center letra-tabla-td">
                        {deu.anio}
                      </td>
                      <td className="p-0 text-center letra-tabla-td">
                        {deu.mes}
                      </td>
                      <td className="p-0 text-end letra-tabla-td">
                        {formatMoneda(
                          deu.monto
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </td>
                      <td className="p-0 text-end letra-tabla-td">
                        {formatMoneda(
                          deu.intereses.replace(",", "").replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </td>
                      <td className="p-0 text-end letra-tabla-td">
                        {formatMoneda(
                          deu.multa.replace(",", "").replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </td>
                      <td className="p-0 text-end letra-tabla-td">
                        {formatMoneda(
                          deu.recargo.replace(",", "").replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </td>
                      <td className="p-0 text-end letra-tabla-td">
                        {formatMoneda(
                          deu.retenciones.replace(",", "").replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </td>
                      <td className="p-0 text-end letra-tabla-td">
                        {formatMoneda(
                          deu.credito.replace(",", "").replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </td>
                      <td className="p-0 text-end letra-tabla-td">
                        {formatMoneda(
                          deu.totalperi
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </td>
                      {
                        deu.status === "Verificando Pago" ? (
                          <td
                            textAlign="center"
                            verticalAlign="middle"
                            style={{ color: "rgb(255, 0, 0 )", padding: "3px" }}
                          >
                            {deu.status}
                            <a
                              href="*"
                              onClick={imprimirPago(index)}
                              className="btn btn-block btn-primary btn-xs"
                            >
                              Consultar Pago
                            </a>
                          </td>
                        ) : (
                          <td
                            textAlign="center"
                            style={{ textAlign: "center", padding: "3px" }}
                          >
                            {deu.status}
                          </td>
                        )
                        /*<button onClick={procesar(index)} className="btn btn-block btn-primary" /><i className="fas fa-sign-in-alt"> Consultar Pago</i> */
                      }
                    </tr>
                  ))}
              </tbody>
            </TblContainer>
            <div style={{ borderTop: 'none', top: -10 }} className="col-12 p-0 m-0 my-2 border-table d-flex align-items-center justify-content-between">
              <div className="col p-0 border-0 p-2 d-flex justify-content-between">
                Monto:
                <span className='fw-bold'>{totalSelect.montoFacturadoSelect}</span>
              </div>
              <div className="col p-0 border-0 p-2 d-flex justify-content-between">
                Interes:
                <span className='fw-bold'>{totalSelect.interesesSelect}</span>
              </div>
              <div className="col p-0 border-0 p-2 d-flex justify-content-between">
                Multa:
                <span className='fw-bold'>{totalSelect.multaSelect}</span>
              </div>
              <div className="col p-0 border-0 p-2 d-flex justify-content-between">
                Recargo:
                <span className='fw-bold'>{totalSelect.recargoSelect}</span>
              </div>
              <div className="col p-0 border-0 p-2 d-flex justify-content-between">
                Retenciones:
                <span className='fw-bold'>{totalSelect.retenSelect}</span>
              </div>
              <div className="col p-0 border-0 p-2 d-flex justify-content-between">
                Credito:
                <span className='fw-bold'>{totalSelect.acrediSelect}</span>
              </div>
              <div className="col p-0 border-0 p-2 fw-bold d-flex justify-content-between">
                Total:
                <span className='fw-bold'>{totalSelect.montoseleccionado}</span>
              </div>
            </div>
            <div className="row col-12 p-0 m-0 border-table" style={{ borderTopStyle: 'hidden', top: -17 }}>
              <div className="col-md-10">
                <div className="d-flex align-items-center mb-1">
                  <span className="fw-bold me-1" style={{ fontFamily: 'Arial, Times, serif', fontSize: '14px' }}>Concepto:</span>
                  <span style={{ fontFamily: 'Arial, Helvetica, sans-serif', fontSize: '14px' }}>{totalSelect.concepto}</span>
                </div>

                <div className="d-flex align-items-center mb-1">
                  <span className="fw-bold me-1" style={{ fontFamily: 'Arial, Times, serif', fontSize: '14px' }}>Seleccionados:</span>
                  <span style={{ fontFamily: 'Arial, Helvetica, sans-serif', fontSize: '14px' }}>{totalSelect.seleccionados}</span>
                </div>

                <div className="d-flex align-items-center mb-1">
                  <span className="fw-bold me-1" style={{ fontFamily: 'Arial, Times, serif', fontSize: '14px' }}>Crédito Fiscal:</span>
                  <span style={{ fontFamily: 'Arial, Helvetica, sans-serif', fontSize: '14px' }}>{totalSelect.acrediSelect}</span>
                </div>

                <div className="d-flex align-items-center">
                  <span className="fw-bold me-1" style={{ fontFamily: 'Arial, Times, serif', fontSize: '14px' }}>Total:</span>
                  <span style={{ fontFamily: 'Arial, Helvetica, sans-serif', fontSize: '14px' }}>{totalSelect.montoseleccionado}</span>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          disabled={btnDisabled}
          onClick={onChangeValidar}
        >
          Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar}>
          Cancelar
        </DangerButton>
      </Modal.Footer>
      <Dimmer active={activate} inverted></Dimmer>

      <AgylsoftModal
        agyl={agyl}
        show={agyl.show}
        onHide={() => setAgyl({ ...agyl, show: false })}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <CatalogoComercio
        titulo={titulo}
        mensaje={msg}
        show={catalogoC}
        onHideCancelaCatCom={handleCatalogo}
        onHideAceptaCatCom={handleAceptaCatalogo}
      />
      <CatalogoInmueble
        titulo={titulo}
        mensaje={msg}
        show={catalogoI}
        onHideCancelaCatInm={handleCatalogo}
        onHideAceptaCatInm={handleAceptaCatalogo}
      />
      <CatalogoVehiculo
        titulo={titulo}
        mensaje={msg}
        show={catalogoV}
        onHideCancela={handleCatalogo}
        onHideAceptaCatCom={handleAceptaCatalogo}
      />
      <CatalagoRentasInmo
        titulo={titulo}
        mensaje={msg}
        show={catalogoA}
        onHideCancelaCatRenta={handleCatalogo}
        onHideAceptaCatRenta={handleAceptaCatalogo}
        codimpu={codImpu}
      />
    </Modal>
  );
};
